import { useEffect, useState } from 'react';
import { useRxCollection } from 'rxdb-hooks';

import { sentryCaptureException } from '../../utilities/sentryCaptureException';
import { RxdbCollectionName } from '../rxdbCollectionName';
import type {
  AssetSectionDefinationsListCollection,
  AssetSectionDefinationsListDocument,
} from './assetSectionDefinition.types';

export const useAssetSectionsDefinations = () => {
  const assetSectionDefinationsListCollection: AssetSectionDefinationsListCollection =
    useRxCollection(RxdbCollectionName.ASSET_SECTION_DEFINATIONS_LIST);

  const [assetSectionDefinationsListInitialized, setAssetSectionDefinationsListInitialized] =
    useState<boolean>(false);

  useEffect(() => {
    if (assetSectionDefinationsListCollection) setAssetSectionDefinationsListInitialized(true);
  }, [assetSectionDefinationsListCollection]);

  const getAssetSectionDefinationsList = async (): Promise<
    AssetSectionDefinationsListDocument[]
  > => {
    if (!assetSectionDefinationsListCollection) return [];
    let assetSectionDefinationsList: AssetSectionDefinationsListDocument[];
    try {
      assetSectionDefinationsList = await assetSectionDefinationsListCollection?.find().exec();
      return assetSectionDefinationsList;
    } catch (error) {
      sentryCaptureException(
        error,
        '🚀 ~ file: useAssetSectionDefinations.ts ~ line 33 ~ getAssetSectionDefinationsList ~ error',
      );
      return [];
    }
  };

  return {
    assetSectionDefinationsListInitialized,
    getAssetSectionDefinationsList,
    assetSectionDefinationsListCollection,
  };
};
